<template>
  <div>
    <div class="pages" v-loading="listLoading">
      <div
          v-for="(item, index) in templateData.TemplateContent.Controls"
          :key="index"
      >
        <Digit v-if="item.Property.Control == 'Number'" :data-val="item"></Digit>
        <Contact
            v-if="item.Property.Control == 'Condition'"
            :data-val="item"
        ></Contact>
        <!--      @child-event="getDateVal"-->
        <Dates
            v-if="item.Property.Control == 'DateTime'"
            :data-val="item"
        ></Dates>
        <Version
            v-if="item.Property.Control == 'Text'"
            @child-event="getTextVal"
            :data-val="item"
        ></Version>
        <Money v-if="item.Property.Control == 'Money'" :data-val="item"></Money>
        <Tips v-if="item.Property.Control == 'Tips'" :data-val="item"></Tips>
        <File v-if="item.Property.Control == 'File'" :data-val="item"></File>
        <Table
            v-if="item.Property.Control == 'Table'"
            @child-event="tableOperation"
            :data-val="item"
        ></Table>
        <Selector
            v-if="item.Property.Control == 'Selector'"
            @child-event="getSelectorVal"
            :data-val="item"
        ></Selector>
        <Textarea
            v-if="item.Property.Control == 'Textarea'"
            :data-val="item"
        ></Textarea>
        <Choose
            v-if="item.Property.Control == 'Contact'"
            @child-event="clickChoose"
            :data-val="item"
        ></Choose>
      </div>
      <h3 style="color: red;text-align: center">小米笔记本摄像头不可用</h3>
      <TimeSlot ref="timeSlot" value1="①小米笔记本" @select-update="SelectUpdate" @submit-val="submitVal" :option-val="optionValues" :user-info="logInfo"></TimeSlot>
      <Button class="submit-process" v-on:click='Transporter' v-bind:disabled="isDisabled" v-bind:loading="formLoading" size="large"
              type="primary"> 提交
      </Button>
    </div>
  </div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from "../components/Number.vue";
import Contact from "../components/Contact.vue";
import Version from "../components/Text.vue";
import Money from "../components/Money.vue";
import Tips from "../components/Tips.vue";
import File from "../components/File.vue";
import Dates from "../components/DateTime.vue";
import Table from "../components/Table.vue";
import Selector from "../components/Selector.vue";
import Textarea from "../components/Textarea.vue";
import Choose from "../components/Choose.vue";
import TimeSlot from "../components/TimeSlot.vue";
import stringUtils from "../assets/js/stringUtil.js";
import {initWxConfig} from "../api/jssdk.js";
import {getTemplateInfo, submitProcessCopy} from "@/api/approval";
import {getRelation} from "@/api/employee";
import {guid} from '@/utils/tableDelete'
import {
  getViolationTimes,
  getBorrowingInformationByTime,
  getResourceBorrowingInfoByArticle,
  getViolationRecordAllAndCount,
  getBlackListByEmpNo,
  getViolationTake,
  checkByEmpNo,
  borrowingInformationsFill,
} from "@/api/ResourceBorrowing";

var isSubmit = false;

var template = {
  TemplateContent: {
    Controls: [],
  },
};
export default {
  components: {
    Contact,
    Version,
    Money,
    Tips,
    File,
    Table,
    Digit,
    Selector,
    Textarea,
    Choose,
    Dates,
    TimeSlot
  },
  data() {
    return {
      templateData: template,
      relationList: null,
      logInfo: null,
      templateId: "",
      spNo: null,
      formLoading: false,
      listLoading: false,
      isDisabled: false,
      listIsShow: false,
      equipmentName: "①小米笔记本",
      borrowingList: [],
      optionValues: [],
      datas: [],
      otherItem: [],
      cellInx: [],
      otherInx: [],
      gathers: [],
      key: null,
      build: null,
      endTimeList: []
    };
  },
  created() {
    this.logInfo = this.getLoginUserInfo();

    initWxConfig(this);
    this.templateId = this.$route.query.templateId;
    this.spNo = this.$route.query.spNo;
    this.getTemplate();
    stringUtils.setAddIsShow(false);
  },
  methods: {
    clickChoose: async function (dataVal, name) {
      var that = this;
      window.wx.invoke(
          "selectEnterpriseContact",
          {
            fromDepartmentId: 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
            mode: "single", // 必填，选择模式，single表示单选，multi表示多选
            type: ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
            selectedDepartmentIds: [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
            selectedUserIds: [], // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          },
          async function (res) {
            if (res.err_msg === "selectEnterpriseContact:ok") {
              if (typeof res.result == "string") {
                res.result = JSON.parse(res.result); //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
              }
              // 已选的部门列表
              var depart = res.result.departmentList[0];
              dataVal.Values = [];
              dataVal.Values.push([depart.id, depart.name]);
              dataVal.Value = depart.name;
            }
          }
      );
    },
    tableOperation(val, type, datas) {
      this.tableoperation(val, type, datas, this);
    },
    getEmployeeRelation: async function () {
      await getRelation(this.logInfo.EmpNo).then((response) => {
        this.relationList = response.Body[0].Nodes;
      });
    },
    getSelectorVal: async function (val, name) {
    },
    getTextVal() {
    },
    buildObject() {
      let IntermediateEntity = {
        /**
         * 借用者姓名
         */
        EmpName: "",

        /**
         * 借用者工号
         */
        EmpNo: "",

        /**
         * 借用者部门
         */
        DeptName: "",

        /**
         * 设备名称
         */
        EquipmentName: "",

        /**
         * 多次借用
         * */
        TimeCollection: [],

        /**
         * 提交时间
         */
        SubmissionTime: "",

        /**
         * 企业微信id
         * */
        ApprovalNumber: ""
      };
      this.filling(IntermediateEntity);
    },
    /**
     * 填充数据
     * @param obj
     * @returns {*}
     */
    filling:async function(obj) {
      obj.EmpName = this.logInfo.EmpName;
      obj.EmpNo = this.logInfo.EmpNo;
      obj.DeptName = this.logInfo.DeptName;
      obj.EquipmentName = this.equipmentName;
      for (let i = 0; i < this.gathers.length; i++){
        const item = this.gathers[i];
        // console.log("item")
        // console.log(item)
        let startTime = this.dateFormat(new Date(item.startTime))
        let endTime = this.dateFormat(new Date(item.endTime))
        this.endTimeList.push(endTime)
        obj.TimeCollection.push({
          StartTime: startTime,
          EndTime: endTime
        })
      }
      obj.SubmissionTime = this.getToDay();
      this.build = obj
    },
    getToDay(){
      var data = new Date();
      var month =
          data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
      var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
      var dateTime = `${data.getFullYear()}-${month}-${date} ${data.getHours()}:${
          data.getMinutes() > 9 ? data.getMinutes() : "0" + data.getMinutes()
      }:${data.getSeconds() > 9 ? data.getSeconds() : "0" + data.getSeconds()}`;
      return dateTime
    },
    /**
     * 添加天数
     * @param arg
     * @param days
     * @returns {string}
     */
    addDate(arg, days, flag) {
      if (days === undefined || days === "") {
        days = 1;
      }
      var date = new Date(arg);
      date.setDate(date.getDate() + days);
      var month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
      var day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
      var hours = date.getHours() > 9 ? date.getHours() : `0${date.getHours()}`;
      var minutes =
          date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`;
      var seconds =
          date.getSeconds() > 9 ? date.getSeconds() : `0${date.getSeconds()}`;
      if (flag)
        return new Date(
            `${date.getFullYear()}/${month}/${day} ${hours}:${minutes}:${seconds}`
        );
      return `${date.getFullYear()}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    getDays(date1, date2) {
      var date1Str = date1.split("-"); //将日期字符串分隔为数组,数组元素分别为年.月.日
      //根据年 . 月 . 日的值创建Date对象
      var date1Obj = new Date(date1Str[0], date1Str[1] - 1, date1Str[2]);
      var date2Str = date2.split("-");
      var date2Obj = new Date(date2Str[0], date2Str[1] - 1, date2Str[2]);
      var t1 = date1Obj.getTime();
      var t2 = date2Obj.getTime();
      var dateTime = 1000 * 60 * 60 * 24; //每一天的毫秒数
      var minusDays = Math.floor((t2 - t1) / dateTime); //计算出两个日期的天数差
      //取绝对值
      return Math.abs(minusDays);
    },
    CheckData(borrowingInformation) {
      let startTime = borrowingInformation.BorrowingStartTime.split(" ")[0];
      let endTime = borrowingInformation.BorrowingEndTime.split(" ")[0];
      return this.getDays(startTime, endTime) > 7;
    },
    CheckTime(borrowingInformation) {
      let startTime = new Date(borrowingInformation.BorrowingStartTime);
      let endTime = new Date(borrowingInformation.BorrowingEndTime);
      let now = new Date();
      if (endTime <= startTime) return "结束时间不能小于或等于开始时间";
      // if (endTime < now)
      //   return "结束时间不能小于当前时间"
      // if (startTime < now) return "开始时间不能小于当前时间";
      return null;
    },
    /**
     * 下拉框发生改变
     * */
    SelectUpdate(value,type){
      if (type === 'update'){
        this.equipmentName = value
        this.key = this.getKeyByValue(value)
      }
    },
    getKeyByValue(value){
      let key;
      this.templateData.TemplateContent.Controls.forEach(item => {
        if (item.Property.Title[0].Text === "借用信息"){
          let children = item.Config.Table.Children
          let options = children.filter(child => child.Property.Title[0].Text === "选择设备")
          options[0].Config.Selector.Options.forEach(option => {
            if(option.Value[0].Text === value){
              key = option.Key
            }
          })
        }
      })
      return key
    },
    getTemplate: async function () {
      var that = this;
      that.listLoading = true;
      const departName = that.logInfo.fullName;
      const jobLevel = that.logInfo.JobLevel;
      const empNo = that.logInfo.EmpNo;
      const empName = that.logInfo.EmpName;
      const positionName = that.logInfo.PositionName;
      // if(departName.indexOf("非营业部/信息中心/业务支持部") === -1 && departName.indexOf("非营业部/信息中心/系统运维部") === -1){
      //   this.Message({
      //     message: "无权限申请",
      //     type: "error",
      //     duration: 3000,
      //   });
      //   this.isDisabled = true;
      //   that.listLoading = false;
      //   return;
      // }
      //判断申请人是否在黑名单中
      await checkByEmpNo(empNo).then(res => {
        let bodys = res.Body;
        if (!bodys) {
          this.Message({
            message: "你未在规定时间内归还资源,已违规,暂无权限申请!",
            type: "error",
            duration: 3000,
          });
          this.isDisabled = true;
        }
      })

      getTemplateInfo(this.templateId).then((response) => {
        var controls = response.Body;
        var that = this;
        let executiveDirector = [];
        for (let i = 0; i < controls.TemplateContent.Controls.length; i++) {
          let item = controls.TemplateContent.Controls[i];
          let propText = item.Property.Title[0].Text;
          if (propText === "姓名" || propText === "工号" || propText === "部门") {
            item.IsShow = false
          }
          if (propText === "借用信息") {
            let children = item.Config.Table.Children;
            this.getChildText(children)
            this.key = "option-1622519420505"
            item.IsShow = false
          }
        }
        this.templateData = this.assignControl(controls, that.logInfo);
        this.listLoading = false;
      });
    },
    submitVal(val, type) {
      if(!val.length > 0){
        this.Message({
          message: "请选择借用时间",
          type: "error",
          duration: 3 * 1000,
        });
        return
      }
      if (type === "submit") {
        let timeArea = []
        for (let i = 0; i < val.length; i++){
          const item = val[i];
          var temp = item.time.indexOf("-") > -1;
          if (temp) {
            let dateOne = `${item.day} ${item.time.split("-")[0]}`.replace(new RegExp('-','g'),"/")
            let dateTwo = `${item.day} ${item.time.split("-")[1]}`.replace(new RegExp('-','g'),"/")
            timeArea.push({
              startTime: new Date(dateOne),
              endTime: new Date(dateTwo),
            })
          }
        }
        timeArea = this.identification(timeArea)
        this.gathers = this.combination(timeArea)
        // 调用提交
        this.submit();
      }
    },
    identification(list){
      for (let i = 0; i < list.length; i++) {
        const item = list[i]
        let inx;
        if(item.endTime.getHours() === 22){
          inx = list.findIndex(e => (e.startTime.getHours() === 9 && e.startTime.getMinutes() === 0) && e.startTime.getDate() === (item.endTime.getDate() + 1))
        }else{
          inx = list.findIndex(e => e.startTime.getHours() === item.endTime.getHours() && e.startTime.getMinutes() === item.endTime.getMinutes() && e.startTime.getDate() === item.endTime.getDate())
        }
        if(inx !== -1) {
          if(item.id === undefined){
            item.id = guid()
          }
          list[inx].id = item.id
        }else{
          if (item.id === undefined){
            item.id = guid()
          }
        }
      }
      return list
    },
    combination(timeArea){
      let results = []
      timeArea.sort((a, b) => {
        return a.startTime > b.startTime ? 1 : -1
      });
      const sorted = this.groupBy(timeArea,function(item) {
        return [item.id]
      })
      sorted.forEach(sort => {
        if(sort.length > 1){
          sort[0].endTime = sort[sort.length - 1].endTime
          delete sort[0].id
          results.push(sort[0])
        }else{
          delete sort[0].id
          results.push(sort[0])
        }
      })
      return results
    },
    groupBy(array, callback) {
      const groups = {};
      array.forEach(function (o) {
        const group = JSON.stringify(callback(o));
        groups[group] = groups[group] || [];
        groups[group].push(o);
      });
      return Object.keys(groups).map(function (group) {
        return groups[group];
      });
    },
    fillingComponent(){
      var copy = null
      let value = this.gathers
      let cls = this.templateData.TemplateContent.Controls;
      let children;
      //对控件进行拷贝
      cls.forEach(cl => {
        if (cl.Property.Title[0].Text === "借用信息") {
          children = cl.Config.Table.Children
          children.forEach(child => {
            if(child.Property.Title[0].Text === "选择设备"){
              child.Value = this.key
            }
          })
          copy = JSON.parse(JSON.stringify(cl))
        }
      })
      //赋值给控件
      if(value.length === 1){
        children.forEach(child => {
          if (child.Property.Title[0].Text === "借用开始时间"){
            child.Value = this.dateFormat(value[0].startTime)
          }
          if (child.Property.Title[0].Text === "借用结束时间"){
            child.Value = this.dateFormat(value[0].endTime)
          }
        })
      }else {
        for (let i = 0; i < value.length; i++) {
          let item = value[i]
          if(i === 0){
            children.forEach(child => {
              if (child.Property.Title[i].Text === "借用开始时间"){
                child.Value = this.dateFormat(value[i].startTime)
              }
              if (child.Property.Title[i].Text === "借用结束时间"){
                child.Value = this.dateFormat(value[i].endTime)
              }
            })
          }else{
            copy.Id = "Table-" + guid()
            copy.Property.Title[0].Text = `${copy.Property.Title[0].Text}${i}`
            let children = copy.Config.Table.Children
            children.forEach(child => {
              if (child.Property.Title[0].Text === "借用开始时间"){
                child.Value = this.dateFormat(value[i].startTime)
              }
              if (child.Property.Title[0].Text === "借用结束时间"){
                child.Value = this.dateFormat(value[i].endTime)
              }
            })
            cls.push(copy)
            copy = JSON.parse(JSON.stringify(copy))
          }
        }
      }
    },
    fillingDto(SpNo){
      this.build.ApprovalNumber = SpNo;
      borrowingInformationsFill(this.build).then(res => {
        console.log(res)
      })
    },
    /**
     * 解析头尾除外元素
     * */
    analysisMiddle(timeZone) {
      timeZone.sort((a, b) => {
        return a.startTime > b.startTime ? 1 : -1
      });
      this.UpdateData(timeZone)
    },
    /**
     * 组合日期
     * */
    UpdateData(timeZone) {
      for (let i = 0; i < timeZone.length; i++) {
        let item = timeZone[i]
        let inx = timeZone.findIndex(e => item.endTime.toLocaleString() === e.startTime.toLocaleString())
        if (inx !== -1) {
          let rm = timeZone.splice(inx, 1)
          item.endTime = rm[0].endTime
          i--
        }
      }
    },
    /**
     * 解析首尾合并日期
     **/
    analysisFrontAndBack(timeFrame) {
      timeFrame.sort((a, b) => {
        return a.startTime > b.startTime ? 1 : -1
      });
      this.findItem(timeFrame)
      this.datas = this.datas.concat(this.otherItem)
      return this.datas
    },
    /**
     * 查询元素
     */
    findItem(timeFrame) {
      for (let i = 0; i < timeFrame.length; i++) {
        const item = timeFrame[i]
        if (i === 0 && item.endTime.getHours() === 22) {
          //第一个 没有上一个
          this.findNext(item, timeFrame, i)
        } else if (i !== timeFrame.length - 1 && item.endTime.getHours() === 22) {
          //其他
          this.findNext(item, timeFrame, i)
        }
      }
      this.collectInx(this.datas, timeFrame)
      for (let i = this.datas.length - 1; i >= 0; i--) {
        let data = this.datas[i]
        let rm = timeFrame.splice(data.next, 1)
        delete data.next
        delete data.index
        data.endTime = rm[0].endTime
      }
    },
    collectInx(datas, timeFrame) {
      datas.forEach(data => {
        if (!this.cellInx.includes(data.next))
          this.cellInx.push(data.next)
        if (!this.cellInx.includes(data.index))
          this.cellInx.push(data.index)
      })
      timeFrame.forEach((item, index) => {
        if (!this.cellInx.includes(index)) {
          this.otherInx.push(index)
        }
      })
      this.otherInx.forEach(other => {
        let item = timeFrame[other]
        this.otherItem.push(item)
      })
    },
    /**
     * 查询下一个元素索引并保存
     */
    findNext(time, timeFrame,inx) {
      let next,start,i = 0;
      do{
        i++
        if(next !== undefined && next !== null){
          time = timeFrame[next]
        }
        next = timeFrame.findIndex(e => e.startTime.getHours() === 9 && e.startTime.getMinutes() === 0 && e.startTime.getDate() === this.upDate(time.startTime, true).getDate())
        if (i === 1){
          start = time.startTime
        }
      }while(next === -1)

      if (next !== -1) {
        let startTime = start;
        let data = {
          startTime,
          next,
          index:inx
        }
        let flag = this.datas.filter(e => e.next === next)
        if (flag.length === 0) {
          this.datas.push(data)
        }
      }
    },
    /**
     * 增加或删除一天
     * @param time
     * @param flag
     * @returns {Date}
     */
    upDate(time, flag) {
      var today = new Date();
      var t;
      if (flag) {
        t = time.getTime() + 1000 * 60 * 60 * 24;
      } else {
        t = time.getTime() - 1000 * 60 * 60 * 24;
      }

      var yesterday = new Date(t);
      return yesterday;
    },
    getChildText(children) {
      let options = children.filter(child => child.Property.Title[0].Text === "选择设备")
      let results = []
      options[0].Config.Selector.Options.forEach(option => {
        results.push(option.Value[0].Text)
      })
      for (let i = 0; i < results.length; i++) {
        this.optionValues.push({
          value: i + 1,
          name: results[i]
        })
      }
    },
    dateFormat(data) {
      var month = data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
      var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
      var dateTime = `${data.getFullYear()}-${month}-${date} ${data.getHours()}:${
          data.getMinutes() > 9 ? data.getMinutes() : "0" + data.getMinutes()
      }:${data.getSeconds() > 9 ? data.getSeconds() : "0" + data.getSeconds()}`;
      // console.log("dateFormat..")
      // console.log(dateTime)
      return dateTime
    },
    Transporter(){
      //调用子组件获取数据 => 子组件调用父组件提交
      this.$refs.timeSlot.defineTime()
    },
    submit: async function () {
      this.isDisabled = true;
      await this.buildObject();
      await getViolationTimes(this.logInfo.EmpNo,this.endTimeList).then(res => {
        let body = res.Body
        for (let i = 0; i < this.build.TimeCollection.length; i++) {
          let item = this.build.TimeCollection[i]
          let filter = body.filter(e => e.Key === item.EndTime)
          if (filter.length > 0){
            item.ViolationTime = filter[0].Value
          }
        }
        this.fillingComponent()
        var SummaryList = [];

        var info = {SummaryInfo: []};
        info.SummaryInfo = [];
        info.SummaryInfo.push({
          Text:
              "借用者：" +
              " " +
              this.logInfo.EmpName +
              " " +
              this.logInfo.EmpNo +
              " " +
              this.logInfo.DeptName,
          Lang: "zh_CN",
        });
        SummaryList.push(info);

        var info = {SummaryInfo: []};
        info.SummaryInfo = [];
        info.SummaryInfo.push({
          Text: "设备名称：" + " " + this.equipmentName,
          Lang: "zh_CN",
        });
        SummaryList.push(info);
        this.build.TimeCollection.forEach(item => {
          var info = {SummaryInfo: []};
          info.SummaryInfo = [];
          info.SummaryInfo.push({
            Text: "借用时间：" + `${item.StartTime} - ${item.EndTime}`,
            Lang: "zh_CN",
          });
          SummaryList.push(info);
        })
        this.templateData.SummaryList = SummaryList;
        //提交
        submitProcessCopy(
            this.templateId,
            this.logInfo.EmpNo,
            this.spNo,
            {
              "dto":this.templateData,
              "intermediateEntityDto":this.build
            }
        )
            .then((response) => {
              if (response.ErrCode !== 0) {
                this.templateData.TemplateContent.Controls.forEach((item) => {
                  if (item.Property.Title[0].Text === "选择借用开始时间") {
                    item.Property.Control = "Text";
                  }
                  if (item.Property.Title[0].Text === "选择借用结束时间") {
                    item.Property.Control = "Text";
                  }
                  if (item.Property.Title[0].Text === "最晚归还期限") {
                    item.IsShow = false;
                  }
                });
                this.Message({
                  message: response.ErrMsg,
                  type: "error",
                  duration: 3 * 1000,
                });
              } else {
                //保存数据
                // this.fillingDto(response.Body.SpNo)
                this.Message({
                  message: "申请成功",
                  type: "success",
                  duration: 3 * 1000,
                });
                setTimeout(() => {
                  this.$router.push("/index");
                }, 3000);
              }
            })
            .catch((err) => {
              this.isDisabled = false;
            })
            .finally(() => {
              isSubmit = false;
              this.listLoading = false;
            });
      })

    },
  }
  ,
}
;
</script>

<style lang="less" scoped>
.pricing-list {
  padding: 10px;
  margin-top: 0px;

  .totle {
    font-size: 12px;
    margin-top: 10px;

    span {
      color: #ff4346;
      padding: 0 4px;
    }
  }

  .pricing-item {
    width: 100%;
    background: #ffffff;
    position: relative;
    padding: 8px;
    margin-top: 10px;
    border-radius: 6px;
    box-shadow: 6px 6px 6px #cccccc;

    .title {
      font-size: 13px;
      color: #585354;
      line-height: 1.8;
      width: calc(100% - 40px);
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      padding-bottom: 4px;
    }

    .applicant-time {
      color: #585354;
      font-size: 12px;
      line-height: 1.7;

      div.applicant {
        width: 80%;
        float: left;
      }

      div.time {
        width: 40%;
        float: right;
        text-align: right;
      }
    }

    .label {
      position: absolute;
      right: 5px;
      top: 10px;
    }

    .waiting-pricing {
      color: #3fc243;
    }

    .waiting-check {
      color: #55acee;
    }
  }

  .pricing-item:first-child {
    margin-top: 0;
  }
}
</style>